import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {SetAgencyClientsPayload, UserStore} from 'client/common/store/reducers/user/types';

const initialState: UserStore = {
    experiments: {},
    query: {},
    lang: 'ru',
    secretkey: '',
    testBuckets: []
};

const slice = createSlice({
    name: 'surveys',
    initialState,
    reducers: {
        fetchAgencyClients() {
            return;
        },
        syncAgencyClients() {
            return;
        },
        setAgencyClients(state, action: PayloadAction<SetAgencyClientsPayload>) {
            const {clients} = action.payload;

            state.clients = clients;
        },
        clearAgencyClients(state) {
            state.clients = undefined;
        }
    }
});

const {actions, reducer} = slice;

export const {
    clearAgencyClients,
    fetchAgencyClients,
    setAgencyClients,
    syncAgencyClients
} = actions;

export default reducer;
